<template>
    <footer class="footer">
        <ul>
            <li>
                <router-link to="/profile" v-slot="{ href, route, navigate, isActive, isExactActive }">
                    <div :class="[
              isActive && 'exact-active',
              isExactActive && 'exact-active',
              'icon-footer-mobile',]" role="button" @click="navigate">
                        <img src="../../assets/image/cluna/main_other_selected.png" />
                        <img src="../../assets/image/cluna/main_other.png" />
                    </div>
                </router-link>
            </li>
            <li>
                <router-link
                        to="/stores"
                        v-slot="{ href, route, navigate, isActive, isExactActive }">
                    <div
                            :class="[isActive && 'active', isExactActive && 'exact-active',
              'icon-footer-mobile',]" role="button" @click="navigate">
                        <img src="../../assets/image/cluna/main_tree_seleted.png"/>
                        <img src="../../assets/image/cluna/main_tree.png"/>
                    </div>
                </router-link>
            </li>
            <li>
                <router-link
                        to="/categories"
                        v-slot="{ href, route, navigate, isActive, isExactActive }"
                >
                    <div
                            :class="[
              isActive && 'active',
              isExactActive && 'exact-active',
              'icon-footer-mobile',
            ]"
                            role="button" @click="navigate"
                    >
                        <img src="../../assets/image/cluna/main_cats_selected.png"/>
                        <img src="../../assets/image/cluna/main_cats.png"/>
                    </div>
                </router-link>
            </li>
            <li>
                <router-link
                        to="/orders"
                        v-slot="{ href, route, navigate, isActive, isExactActive }"
                >
                    <div
                            :class="[
              isActive && 'active',
              isExactActive && 'exact-active',
              'icon-footer-mobile',
            ]"
                            role="button" @click="navigate"
                    >
                        <img src="../../assets/image/cluna/main_history_selected.png" />
                        <img src="../../assets/image/cluna/main_history.png" />
                    </div>
                </router-link>
            </li>
            <li>
                <router-link
                        to="/main"
                        v-slot="{ href, route, navigate, isActive, isExactActive }">
                    <div
                            :class="[isActive && 'active', isExactActive && 'exact-active', 'icon-footer-mobile',]"
                            role="button" @click="navigate">
                        <img src="../../assets/image/cluna/main_home_selected.png"/>
                        <img src="../../assets/image/cluna/main_home.png"/>
                    </div>
                </router-link>
            </li>
        </ul>
    </footer>
</template>
<script>
    export default {
        name: "Footer",
        data: () => ({
        }),
        methods: {
        },
    };
</script>
<style>

    .footer {
        background: #fff;
        position: fixed;
        width: 100%;
        right: 0;
        bottom: 0;
        padding: 15px 20px;
        box-shadow: 0 3px 10px -5px #000;
    }

    .footer ul {
        padding-left: 5px;
        padding-right: 5px;
        display: flex;
        justify-content: space-between;
        flex-direction: row-reverse;
        align-items: center;
        align-content: center
    }

    .footer ul li a {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #707070;
        text-decoration: none;
    }

    .footer ul li a span {
        font-size: 13px;
    }

    .footer ul li a i {
        color: #707070;
    }

    .footer ul li a i {
        color: #707070 !important;
    }

    .footer ul li div.exact-active,
    .footer ul li div.exact-active i {
        color: #011d33 !important;
    }

    .footer .slideShow .v-icon {
        transform: rotate(270deg);
    }

    .footer .theme--light.v-icon {
        color: #707070;
    }

    .footer .icon-footer-mobile {
        width: 21px;
    }

    .footer .icon-footer-mobile img {
        width: 100%;
    }

    .footer .icon-footer-mobile img:nth-child(1) {
        display: none;
    }


    .footer  .exact-active img:nth-child(2){
        display: none;
    }

    .footer .exact-active img:nth-child(1){
        display: unset;
    }
</style>
